/* eslint-disable @typescript-eslint/no-explicit-any,@typescript-eslint/no-non-null-assertion */
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { EmployeeDetailsService } from '@core/services/employee/employee.details.service';
import { InjectorKeys } from '@core/utils/injector.keys';
import { EMPTY, Observable } from 'rxjs';
import { EmployeeDetails } from '@core/models/employee';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { UserService } from '@core/services/user/user.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {ActivatedRoute, Router} from '@angular/router';

@UntilDestroy()
@Component({
  selector: 'app-employee-details',
  templateUrl: './employee-details.component.html',
  styleUrls: ['./employee-details.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EmployeeDetailsComponent implements OnInit, OnChanges {
  @Input() employeeId: string | undefined;
  @Input() openIcon: IconProp = faPlus;
  @Input() closeIcon: IconProp = faMinus;
  @Output() closeClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() companySelected: EventEmitter<string> = new EventEmitter<string>();
  @Output() locationSelected: EventEmitter<string> = new EventEmitter<string>();
  @Output() boardSelected: EventEmitter<string> = new EventEmitter<string>();

  public employee$: Observable<EmployeeDetails> = EMPTY;
  public isAdmin = false;
  highlightedSkill: string | null = null;

  constructor(
    @Inject(InjectorKeys.EMPLOYEE_DETAILS_SERVICE) private service: EmployeeDetailsService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.reloadEmployee();
    this.updateAdminStatus();
    this.route.queryParamMap.subscribe(params => {
      this.highlightedSkill = params.get('highlightSkill');
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['employeeId']) {
      this.reloadEmployee();
    }
  }

  public onCloseButtonClicked(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { employee: null },
      queryParamsHandling: 'merge'
    });
    this.closeClicked.emit();
  }

  private updateAdminStatus() {
    this.userService
      .getAdminStatus()
      .pipe(untilDestroyed(this))
      .subscribe((value: boolean) => {
        this.isAdmin = value;
      });
  }

  private reloadEmployee() {
    this.employee$ = this.employeeId ? this.service.get(this.employeeId) : EMPTY;
  }

  public companySelect(company: string) {
    this.companySelected.emit(company);
  }

  public locationSelect(location: string) {
    this.locationSelected.emit(location);
  }

  public boardSelect(board: string) {
    this.boardSelected.emit(board);
  }
}
